import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { MachineGroupsResponse } from '../types/machine-setup-types';

export class GetMachineGroupsUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(actorId: number): Promise<MachineGroupsResponse> {
    return this.repository.getMachineGroups(actorId);
  }
}
